import { useEffect, useRef } from 'react';

function CheckboxFilter({
  id,
  text,
  iconSrc = undefined,
  iconAltText = '',
  checked,
  className = '',
  onChange,
}: {
  id: string;
  text: string;
  iconSrc?: string;
  iconAltText?: string;
  checked: boolean | undefined;
  className?: string;
  ariaControls?: string;
  onChange: (checked: boolean) => void;
}) {
  // === REFS ===
  const inputRef = useRef<HTMLInputElement>(null);

  // === EFFECTS ===
  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.indeterminate = checked === undefined;
    }
  }, [checked]);

  // === EVENT HANDLERS ===
  function handleChange() {
    onChange(checked === undefined ? true : !checked);
  }

  return (
    <div className={`form-check d-flex align-items-center ${className}`}>
      <input id={id} type="checkbox" className="form-check-input mt-0 me-2" name={id} checked={checked} onChange={handleChange} />
      {/* eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions */}
      <label className="form-check-label d-flex align-items-center" htmlFor={id} onKeyUp={handleChange}>
        {iconSrc && <img className="me-1" src={iconSrc} alt={iconAltText} />}
        {text}
      </label>
    </div>
  );
}

export default CheckboxFilter;
